import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Master_ScreenProvider } from "../screens/master/master-context";
import { PushTest_Screen } from "../screens/pushtest/pushtest";
import { Kisi_List_Screen } from "../screens/kisi_list/kisi_list";
import { User_List_Screen } from "../screens/user_list/user_list";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { BakimOzet_Screen } from "../screens/bakimozet/bakimozet";
import { Deneme_Screen } from "../screens/deneme/deneme";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { DosyaGoster_Screen } from "../screens/dosyagoster/dosyagoster";
import { User_Form_Screen } from "../screens/user_form/user_form";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { MesajKutusu_Screen } from "../screens/mesajkutusu/mesajkutusu";
import { BakimForm_Screen } from "../screens/bakimform/bakimform";
import { BakimNedeni_List_Screen } from "../screens/bakimnedeni_list/bakimnedeni_list";
import { BildirimList_Screen } from "../screens/bildirimlist/bildirimlist";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { RezervasyonForm_Screen } from "../screens/rezervasyonform/rezervasyonform";
import { Sirket_List_Screen } from "../screens/sirket_list/sirket_list";
import { UcusSureRaporu_Screen } from "../screens/ucussureraporu/ucussureraporu";
import { Ucak_List_Screen } from "../screens/ucak_list/ucak_list";
import { BakimListe_Screen } from "../screens/bakimliste/bakimliste";
import { YolcuForm_Screen } from "../screens/yolcuform/yolcuform";
import { TarihTest_Screen } from "../screens/tarihtest/tarihtest";
import { UcusListe_Screen } from "../screens/ucusliste/ucusliste";
import { Master_Screen } from "../screens/master/master";
import { Aktarim_Screen } from "../screens/aktarim/aktarim";
import { BakimNedeni_Form_Screen } from "../screens/bakimnedeni_form/bakimnedeni_form";
import { TarihceList_Screen } from "../screens/tarihcelist/tarihcelist";
import { RezervasyonOzet_Screen } from "../screens/rezervasyonozet/rezervasyonozet";
import { MasrafCesidi_List_Screen } from "../screens/masrafcesidi_list/masrafcesidi_list";
import { Kisi_Form_Screen } from "../screens/kisi_form/kisi_form";
import { Signin_Screen } from "../screens/signin/signin";
import { DbForm_Screen } from "../screens/dbform/dbform";
import { Sirket_Form_Screen } from "../screens/sirket_form/sirket_form";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { MasrafCesidi_Form_Screen } from "../screens/masrafcesidi_form/masrafcesidi_form";
import { Authentication_Reset_Password_Screen } from "../screens/authentication_reset_password/authentication_reset_password";
import { UcusForm_Screen } from "../screens/ucusform/ucusform";
import { Kisi_View_Screen } from "../screens/kisi_view/kisi_view";
import { Ucak_Form_Screen } from "../screens/ucak_form/ucak_form";
import { RezervasyonListe_Screen } from "../screens/rezervasyonliste/rezervasyonliste";
import { Signup_Screen } from "../screens/signup/signup";
import { MasrafForm_Screen } from "../screens/masrafform/masrafform";
import { MasrafRaporu_Screen } from "../screens/masrafraporu/masrafraporu";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  external_provider_type?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
                        <PrivateRoute exact path="/" component={HomePage_Screen} />
                        <PrivateRoute exact path="/pushtest" component={PushTest_Screen} />
            <PrivateRoute exact path="/kisi_list" component={Kisi_List_Screen} />
            <PrivateRoute exact path="/user_list" component={User_List_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <PrivateRoute exact path="/bakimozet" component={BakimOzet_Screen} />
            <PrivateRoute exact path="/deneme" component={Deneme_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/dosyagoster" component={DosyaGoster_Screen} />
            <PrivateRoute exact path="/user_form" component={User_Form_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/mesajkutusu" component={MesajKutusu_Screen} />
            <PrivateRoute exact path="/bakimform" component={BakimForm_Screen} />
            <PrivateRoute exact path="/bakimnedeni_list" component={BakimNedeni_List_Screen} />
            <PrivateRoute exact path="/bildirimlist" component={BildirimList_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/rezervasyonform" component={RezervasyonForm_Screen} />
            <PrivateRoute exact path="/sirket_list" component={Sirket_List_Screen} />
            <PrivateRoute exact path="/ucussureraporu" component={UcusSureRaporu_Screen} />
            <PrivateRoute exact path="/ucak_list" component={Ucak_List_Screen} />
            <PrivateRoute exact path="/bakimliste" component={BakimListe_Screen} />
            <PrivateRoute exact path="/yolcuform" component={YolcuForm_Screen} />
            <PrivateRoute exact path="/tarihtest" component={TarihTest_Screen} />
            <PrivateRoute exact path="/ucusliste" component={UcusListe_Screen} />
            <PrivateRoute exact path="/aktarim" component={Aktarim_Screen} />
            <PrivateRoute exact path="/bakimnedeni_form" component={BakimNedeni_Form_Screen} />
            <PrivateRoute exact path="/tarihcelist" component={TarihceList_Screen} />
            <PrivateRoute exact path="/rezervasyonozet" component={RezervasyonOzet_Screen} />
            <PrivateRoute exact path="/masrafcesidi_list" component={MasrafCesidi_List_Screen} />
            <PrivateRoute exact path="/kisi_form" component={Kisi_Form_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <Route exact path="/signin" component={Signin_Screen} />
            <PrivateRoute exact path="/dbform" component={DbForm_Screen} />
            <PrivateRoute exact path="/sirket_form" component={Sirket_Form_Screen} />
            <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
            <PrivateRoute exact path="/masrafcesidi_form" component={MasrafCesidi_Form_Screen} />
            <Route exact path="/authentication_reset_password" component={Authentication_Reset_Password_Screen} />
            <PrivateRoute exact path="/ucusform" component={UcusForm_Screen} />
            <PrivateRoute exact path="/kisi_view" component={Kisi_View_Screen} />
            <PrivateRoute exact path="/ucak_form" component={Ucak_Form_Screen} />
            <PrivateRoute exact path="/rezervasyonliste" component={RezervasyonListe_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <PrivateRoute exact path="/masrafform" component={MasrafForm_Screen} />
            <PrivateRoute exact path="/masrafraporu" component={MasrafRaporu_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    // Embedded MFE containers need to know whose routing space window.location.hash
    // is: theirs (pathname-routed shell) or the shell's own. A hash-routed shell
    // means a hash is never a microapp deep link — see mfe-initial-navigation.ts.
    //
    // First writer wins: an embedded microapp bundle runs its own copy of this
    // Router (always a HashRouter) on the SAME window, and it must not overwrite the
    // shell's answer. The shell's route tree renders before it can load any bundle,
    // so the first write is always the outermost app's.
    const isHashRouted: boolean = isWebComponentApp === true || this.props.routerType === "HashRouter";
    if (window.kuika.isShellHashRouted === undefined) {
      window.kuika.isShellHashRouted = isHashRouted;
    }

    if (isHashRouted) {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    const { external_provider_type } = this.props;
    // A Kuika host injects external_access_token as a short-lived MFE handoff
    // JWT; no refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed. A non-Kuika host injects its
    // own token plus external_provider_type, naming the customer's
    // External1..External5 validator that will verify it.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
            external_provider_type={external_provider_type}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
